import { Component, Input, OnInit } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsTooltipModule } from '@cds/ng-web-components/tooltip';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-tooltip-icon',
  templateUrl: './tooltip-icon.component.html',
  styleUrls: ['./tooltip-icon.component.scss'],
  imports: [CdsIconModule, CdsTooltipModule, CdsLanguageModule],
})
export class TooltipIconComponent implements OnInit {
  @Input() tooltipString = '';
  @Input() tooltipMaxWidth?: number;
  @Input() tooltipPanelClass = '';

  constructor() {}

  ngOnInit(): void {}

  onCanDelegateAmtToggle(event: MouseEvent) {
    const target = event.target as HTMLElement | null;

    if (target) {
      target.dispatchEvent(new Event('click'));
      this.applyTooltipMaxWidth(target);
    }
  }

  private applyTooltipMaxWidth(triggerEl: HTMLElement, attempt = 0): void {
    if (!this.tooltipMaxWidth && !this.tooltipPanelClass) {
      return;
    }

    setTimeout(
      () => {
        const tooltipBox = this.resolveTooltipBox(triggerEl);

        if (!tooltipBox) {
          if (attempt < 8) {
            this.applyTooltipMaxWidth(triggerEl, attempt + 1);
          }
          return;
        }

        if (this.tooltipPanelClass) {
          tooltipBox.classList.add(this.tooltipPanelClass);
        }

        if (!this.tooltipMaxWidth) {
          return;
        }

        const appliedWidth = Math.min(this.tooltipMaxWidth, Math.max(window.innerWidth - 64, 280));
        const content = tooltipBox.querySelector('.tippy-content') as HTMLElement | null;

        tooltipBox.style.minWidth = `${appliedWidth}px`;
        tooltipBox.style.width = `${appliedWidth}px`;
        tooltipBox.style.maxWidth = `${appliedWidth}px`;

        if (content) {
          content.style.width = '100%';
          content.style.minWidth = '100%';
          content.style.maxWidth = `${appliedWidth}px`;
          content.style.whiteSpace = 'normal';
          content.style.wordWrap = 'break-word';
          content.style.overflowWrap = 'break-word';
        }
      },
      attempt === 0 ? 0 : 50
    );
  }

  private resolveTooltipBox(triggerEl: HTMLElement): HTMLElement | undefined {
    const describedBy = triggerEl.getAttribute('aria-describedby');

    if (describedBy) {
      const describedElement = document.getElementById(describedBy);
      if (describedElement) {
        if (describedElement.matches(".tippy-box[data-theme~='cds-tooltip']")) {
          return describedElement as HTMLElement;
        }

        const nestedTooltipBox = describedElement.querySelector(".tippy-box[data-theme~='cds-tooltip']") as HTMLElement | null;
        if (nestedTooltipBox) {
          return nestedTooltipBox;
        }
      }
    }

    const tooltipBoxes = Array.from(document.querySelectorAll(".tippy-box[data-theme~='cds-tooltip']")) as HTMLElement[];
    const visibleTooltipBoxes = tooltipBoxes.filter(tooltipBox => tooltipBox.getAttribute('data-state') === 'visible');

    return visibleTooltipBoxes[visibleTooltipBoxes.length - 1];
  }
}
